import ProductReviewList from "./ProductReviewList";

export default ProductReviewList;
